import React from 'react';

import './Footer.css';

function Footer() {
    return (
        <div className="footer">
            <div className="long-divider"></div>
            <p>Jerry Mras-Swan</p>
            <div className="row">
                <a href='https://www.linkedin.com/in/gerald-swan/' target="_blank">LinkedIn</a>
                <a href='https://github.com/swanj21' target="_blank">Github</a>
                <a href='mailto:swanj21@gmail.com'>Email</a>
            </div>
        </div>
    )
}

export default Footer;